export default "__VITE_ASSET__S50RvY8e__"